import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IzbAtCOP = ({question,answer}) => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowLeft}
      className={className}
      style={{
        ...style,
        display: "block",
        width: "50px",
        height: "50px",
        left: "-58px",
        zIndex:"99"
      }}
      onClick={onClick}
    />
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowRight}
      className={className}
 
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}; 
  
  return (
    <>
      <Breadcrumb2
        Heading="Latest News"
        img={BackgroundBrundcrumb}
        show={true}
      
      />

        <section>
            <div className="container pt-5">
              <h1 className="pb-5 text-left">Indo Zambia Bank is here at COP29!</h1>

                <p className="pb-3">Indo Zambia Bank was proud to attend the COP29 UN Climate Change Conference in Baku, Azerbaijan. Staying at the forefront of climate action, we are committed to innovative solutions for a sustainable future.</p>

                <p className="pb-3">We are proud to join leaders from around the world at COP29 in Baku, Azerbaijan, supporting global efforts to tackle climate change.
                On a panel discussion Indo Zambia Bank joined in collaboration with World Wildlife Fund (WWF) at the ongoing COP 29 in Baku, Azerbaijan.
                Title: " Green Gains: Where Conservation meets Capital ".</p>

                <p className="pb-3">Together, we can drive impactful change in Solidarity for a Green World!</p>

              <h2 className="pt-4 pb-4">Gallery</h2>
            
              <div className="test news-slider-list-slider row align-items-center">
                <Slider {...settings}>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo-Zambia-Bank-COP29.png" alt="" />
                  </div>
                </Slider>
              </div>
            </div>

        </section>

      <CustomerCare />
      <OurStores />

    </>
  );
};

export default IzbAtCOP;